var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8791 23.4038C5.071 22.4618 0.232553 17.0667 1.0461 11.3291C1.81682 5.59146 7.98263 1.73784 14.7907 2.72265C21.5988 3.66465 26.4372 9.10255 25.6237 14.7974C24.8102 20.535 18.6443 24.3886 11.8791 23.4038V23.4038Z",
    fill: "url(#paint0_linear_1_311)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0073 22.3763C5.88429 21.5199 1.51684 16.6387 2.24475 11.5005C2.97266 6.36231 8.53901 2.89404 14.662 3.7504C20.7422 4.60676 25.1096 9.48803 24.3817 14.6262C23.6538 19.7644 18.1303 23.2326 12.0073 22.3763V22.3763Z",
    fill: "url(#paint1_linear_1_311)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0476 0.88145C21.8557 1.82345 26.6941 7.26135 25.8806 12.9562L25.6237 14.7973C26.4372 9.10253 21.5988 3.66463 14.7907 2.72263C7.98262 1.73781 1.81681 5.59144 1.04608 11.3291L1.30299 9.4879C2.11653 3.75027 8.28234 -0.103367 15.0476 0.88145V0.88145Z",
    fill: "url(#paint2_linear_1_311)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4245 14.4983C24.4245 14.5269 24.4103 14.5697 24.3817 14.6268C23.6538 19.765 18.1303 23.2332 12.0073 22.3769C5.88429 21.5205 1.51684 16.6392 2.24475 11.5011C2.27329 11.444 2.28757 11.3869 2.28757 11.3298C1.64529 16.4251 6.01274 21.2208 12.0501 22.0771C18.0875 22.9335 23.611 19.5509 24.4245 14.4983V14.4983Z",
    fill: "#7E470D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_311",
    x1: -0.495355,
    y1: 15.4825,
    x2: 1.26019,
    y2: 3.02238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_311",
    x1: 27.85,
    y1: -2.50105,
    x2: 24.2104,
    y2: 23.0614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_311",
    x1: 2.37344,
    y1: -1.73046,
    x2: 25.8378,
    y2: 1.56654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin5);
export default __webpack_public_path__ + "static/media/coin5.11aa536a115bae0ba0328fa23745bf16.svg";
export { ForwardRef as ReactComponent };